import { ToggleGroup } from 'radix-ui';
import styled from 'styled-components';

export const Item = styled(ToggleGroup.Item)`
  all: unset;
  background-color: transparent;
`;
